function toVisualMediaProperty(prop) {
    if (prop === undefined || prop === null) {
        return [];
    }
    if (Array.isArray(prop)) {
        return prop.map(function (element) {
            if (element !== null &&
                element !== undefined &&
                typeof element === 'object' &&
                'media_url' in element &&
                'media_type' in element) {
                return {
                    media_url: element['media_url'],
                    media_type: element['media_type'],
                    display_url: element['display_url'],
                    thumbnail_url: element['thumbnail_url'],
                };
            }
            return {
                media_url: '',
                media_type: '',
            };
        });
    }
    console.info('Got non-array prop value for toVisualMediaProperty:', prop);
    throw Error('toVisualMediaProperty() requires an Array');
}
var POST_FIELDS = [
    {
        apiKey: 'clickthrough_link.long',
        column: {
            id: 'clickthrough_link_long',
            dataType: 'string',
            alias: 'Clickthrough Link Long',
            description: 'Long version of link to another entity that appears on the message, e.g. when a Pinterest message contains a link to a different website.',
        },
    },
    {
        apiKey: 'clickthrough_link.name',
        column: {
            id: 'clickthrough_link_name',
            dataType: 'string',
            alias: 'Clickthrough Link Name',
            description: 'Name of a link to another entity that appears on the message, e.g. when a Pinterest message contains a link to a different website.',
        },
    },
    {
        apiKey: 'clickthrough_link.short',
        column: {
            id: 'clickthrough_link_short',
            dataType: 'string',
            alias: 'Clickthrough Link Short',
            description: 'Short version of a link to another entity that appears on the message, e.g. when a Pinterest message contains a link to a different website.',
        },
    },
    {
        apiKey: 'content_category',
        column: {
            id: 'content_category',
            dataType: 'string',
            alias: 'Content Category',
            description: 'Unified categorization of the content. The hierarchy is album, video, photo, link, or text.',
        },
    },
    {
        apiKey: 'created_time',
        column: {
            id: 'created_time',
            dataType: 'datetime',
            alias: 'Created Time',
            description: 'An iso8601 timestamp representing the publication date and time of the message.',
        },
    },
    {
        apiKey: 'customer_profile_id',
        postProcess: function (value) {
            // NOTE: customer profile ids are strings on this endpoint
            if (value !== undefined && value !== null) {
                return parseInt(value);
            }
            return null;
        },
        column: {
            id: 'customer_profile_id',
            dataType: 'int',
            alias: 'Customer Profile ID',
            description: 'ID of the profile associated with this message.',
        },
    },
    {
        apiKey: 'from.guid',
        column: {
            id: 'from_guid',
            dataType: 'string',
            alias: 'From GUID',
            description: 'The native ID of the authors\' profile prefixed with a Sprout code that represents where the data was collected.',
        },
    },
    {
        apiKey: 'from.name',
        column: {
            id: 'from_name',
            dataType: 'string',
            alias: 'From Name',
            description: 'The display name of the author.',
        },
    },
    {
        apiKey: 'from.profile_picture',
        column: {
            id: 'from_profile_picture',
            dataType: 'string',
            alias: 'From Profile Picture',
            description: 'URL to the profile’s picture.',
        },
    },
    {
        apiKey: 'from.screen_name',
        column: {
            id: 'from_screen_name',
            dataType: 'string',
            alias: 'From Screen Name',
            description: 'Also commonly called "handle," this field is mutable on most networks, but not changed as often as the display name.',
        },
    },
    {
        apiKey: 'guid',
        column: {
            id: 'guid',
            dataType: 'string',
            alias: 'GUID',
            description: 'The native ID of the message prefixed with a Sprout code that represents where this type of message is.',
        },
    },
    {
        apiKey: 'hashtags',
        column: {
            id: 'hashtags',
            dataType: 'string',
            alias: 'Hashtags',
            description: 'Array of hashtags associated with the message (does not include the "#" character).',
        },
        postProcess: function (value) {
            if (value !== undefined && value !== null) {
                return value.join(',');
            }
            return '';
        }
    },
    {
        apiKey: 'internal.sent_by.id',
        column: {
            id: 'internal_sent_by_id',
            dataType: 'int',
            alias: 'Internal Sent By ID',
            description: 'ID of the team member that sent this message via Sprout.',
        },
    },
    {
        apiKey: 'internal.sent_by.email',
        column: {
            id: 'internal_sent_by_email',
            dataType: 'string',
            alias: 'Internal Sent By Email',
            description: 'Email address of the team member that sent this message.',
        },
    },
    {
        apiKey: 'internal.sent_by.first_name',
        column: {
            id: 'internal_sent_by_first_name',
            dataType: 'string',
            alias: 'Internal Sent By First Name',
            description: 'First name of the team member that sent this message.',
        },
    },
    {
        apiKey: 'internal.sent_by.last_name',
        column: {
            id: 'internal_sent_by_last_name',
            dataType: 'string',
            alias: 'Internal Sent By Last Name',
            description: 'Last name of the team member that sent this message.',
        },
    },
    {
        apiKey: 'internal.tags',
        column: {
            id: 'internal_tags_ids',
            dataType: 'string',
            alias: 'Internal Tag Ids',
            description: 'Comma separated list of internal tag ids applied to this message',
        },
        postProcess: function (value) {
            return (value || []).map(function (_a) {
                var id = _a.id;
                return id;
            }).join(',');
        },
    },
    {
        apiKey: 'network',
        column: {
            id: 'network',
            dataType: 'string',
            alias: 'Network',
            description: 'The social network that the data came from (e.g. INSTAGRAM).',
        },
    },
    {
        apiKey: 'perma_link',
        column: {
            id: 'perma_link',
            dataType: 'string',
            alias: 'Perma Link',
            description: 'URL to the message on the social network.',
        },
    },
    {
        apiKey: 'pinterest.board_name',
        column: {
            id: 'pinterest_board_name',
            dataType: 'string',
            alias: 'Pinterest Board Name',
            description: 'The name of the collection where users save specific pins.',
        },
    },
    {
        apiKey: 'post_category',
        column: {
            id: 'post_category',
            dataType: 'string',
            alias: 'Post Category',
            description: 'A unified version of post_type, these names are not network specific.',
        },
    },
    {
        apiKey: 'post_type',
        column: {
            id: 'post_type',
            dataType: 'string',
            alias: 'Post Type',
            description: 'Uniquely identifies the social network and type of message this is. Refer to the Post Types table for full list of valid post_types: https://api.sproutsocial.com/docs/#post_types',
        },
    },
    {
        apiKey: 'profile_guid',
        column: {
            id: 'profile_guid',
            dataType: 'string',
            alias: 'Profile GUID',
            description: 'The ID of the profile being tracked prefixed with an Sprout code that represents where the data was collected. When the message was made by the profile being tracked, this field will be identical to from.guid.',
        },
    },
    {
        apiKey: 'text',
        column: {
            id: 'text',
            dataType: 'string',
            alias: 'Text',
            description: 'The text in the body of the message.',
        },
    },
    {
        apiKey: 'title',
        column: {
            id: 'title',
            dataType: 'string',
            alias: 'Title',
            description: 'Text that is separate from the usual body of the message, usually shown as a title for the message in the social network.',
        },
    },
    {
        apiKey: 'visual_media',
        column: {
            id: 'primary_visual_media_url',
            dataType: 'string',
            alias: 'Primary Visual Media URL',
            description: 'URL for the first piece of media shared on the post.'
        },
        postProcess: function (value) {
            var _a;
            var visualMedia = toVisualMediaProperty(value);
            return (_a = visualMedia === null || visualMedia === void 0 ? void 0 : visualMedia[0]) === null || _a === void 0 ? void 0 : _a.media_url;
        },
    },
    {
        apiKey: 'visual_media',
        column: {
            id: 'primary_visual_media_type',
            dataType: 'string',
            alias: 'Primary Visual Media Type',
            description: 'Type of the first piece of media shared on the post.'
        },
        postProcess: function (value) {
            var _a;
            var visualMedia = toVisualMediaProperty(value);
            return (_a = visualMedia === null || visualMedia === void 0 ? void 0 : visualMedia[0]) === null || _a === void 0 ? void 0 : _a.media_type;
        },
    },
    {
        apiKey: 'visual_media',
        column: {
            id: 'primary_visual_media_thumbnail_url',
            dataType: 'string',
            alias: 'Primary Visual Media Thumbnail URL',
            description: 'Thumbnail URL for first piece of media shared on the post.'
        },
        postProcess: function (value) {
            var _a;
            var visualMedia = toVisualMediaProperty(value);
            return (_a = visualMedia === null || visualMedia === void 0 ? void 0 : visualMedia[0]) === null || _a === void 0 ? void 0 : _a.thumbnail_url;
        },
    },
];
var POST_METRICS = [
    {
        apiKey: 'lifetime.annotation_click_through_rate',
        column: {
            id: 'lifetime_annotation_click_through_rate',
            dataType: 'float',
            alias: 'Annotation Click Rate',
        },
    },
    {
        apiKey: 'lifetime.annotation_clickable_impressions',
        column: {
            id: 'lifetime_annotation_clickable_impressions',
            dataType: 'int',
            alias: 'Clickable Annotation Impressions',
        },
    },
    {
        apiKey: 'lifetime.annotation_clicks',
        column: {
            id: 'lifetime_annotation_clicks',
            dataType: 'int',
            alias: 'Annotation Clicks',
        },
    },
    {
        apiKey: 'lifetime.annotation_closable_impressions',
        column: {
            id: 'lifetime_annotation_closable_impressions',
            dataType: 'int',
            alias: 'Closable Annotation Impressions',
        },
    },
    {
        apiKey: 'lifetime.annotation_close_rate',
        column: {
            id: 'lifetime_annotation_close_rate',
            dataType: 'int',
            alias: 'Annotation Close Rate',
        },
    },
    {
        apiKey: 'lifetime.annotation_closes',
        column: {
            id: 'lifetime_annotation_closes',
            dataType: 'int',
            alias: 'Annotation Closes',
        },
    },
    {
        apiKey: 'lifetime.annotation_impressions',
        column: {
            id: 'lifetime_annotation_impressions',
            dataType: 'int',
            alias: 'Annotation Impressions',
        },
    },
    {
        apiKey: 'lifetime.card_click_rate',
        column: {
            id: 'lifetime_card_click_rate',
            dataType: 'int',
            alias: 'Card Click Rate',
        },
    },
    {
        apiKey: 'lifetime.card_clicks',
        column: {
            id: 'lifetime_card_clicks',
            dataType: 'int',
            alias: 'Card Clicks',
        },
    },
    {
        apiKey: 'lifetime.card_impressions',
        column: {
            id: 'lifetime_card_impressions',
            dataType: 'int',
            alias: 'Card Impressions',
        },
    },
    {
        apiKey: 'lifetime.card_teaser_click_rate',
        column: {
            id: 'lifetime_card_teaser_click_rate',
            dataType: 'float',
            alias: 'Card Teaser Click Rate',
        },
    },
    {
        apiKey: 'lifetime.card_teaser_clicks',
        column: {
            id: 'lifetime_card_teaser_clicks',
            dataType: 'int',
            alias: 'Card Teaser Clicks',
        },
    },
    {
        apiKey: 'lifetime.card_teaser_impressions',
        column: {
            id: 'lifetime_card_teaser_impressions',
            dataType: 'int',
            alias: 'Card Teaser Impressions',
        },
    },
    {
        apiKey: 'lifetime.comments_count',
        column: {
            id: 'lifetime_comments_count',
            dataType: 'int',
            alias: 'Comments',
        },
    },
    {
        apiKey: 'lifetime.dislikes',
        column: {
            id: 'lifetime_dislikes',
            dataType: 'int',
            alias: 'Video Dislikes',
        },
    },
    {
        apiKey: 'lifetime.engagements_follower_unique',
        column: {
            id: 'lifetime_engagements_follower_unique',
            dataType: 'int',
            alias: 'Engaged Fans',
        },
    },
    {
        apiKey: 'lifetime.engagements_other',
        column: {
            id: 'lifetime_engagements_other',
            dataType: 'int',
            alias: 'Other Engagements',
        },
    },
    {
        apiKey: 'lifetime.engagements_unique',
        column: {
            id: 'lifetime_engagements_unique',
            dataType: 'int',
            alias: 'Engaged Users',
        },
    },
    {
        apiKey: 'lifetime.estimated_minutes_watched',
        column: {
            id: 'lifetime_estimated_minutes_watched',
            dataType: 'int',
            alias: 'Estimated Minutes Watched',
        },
    },
    {
        apiKey: 'lifetime.estimated_red_minutes_watched',
        column: {
            id: 'lifetime_estimated_red_minutes_watched',
            dataType: 'int',
            alias: 'Estimated YT Red Minutes Watched',
        },
    },
    {
        apiKey: 'lifetime.impression_source_follow',
        column: {
            id: 'lifetime_impression_source_follow',
            dataType: 'int',
            alias: 'Impression Source Follow',
        },
    },
    {
        apiKey: 'lifetime.impression_source_for_you',
        column: {
            id: 'lifetime_impression_source_for_you',
            dataType: 'int',
            alias: 'Impression Source For You',
        },
    },
    {
        apiKey: 'lifetime.impression_source_hashtag',
        column: {
            id: 'lifetime_impression_source_hashtag',
            dataType: 'int',
            alias: 'Impression Source Hashtag',
        },
    },
    {
        apiKey: 'lifetime.impression_source_personal_profile',
        column: {
            id: 'lifetime_impression_source_personal_profile',
            dataType: 'int',
            alias: 'Impression Source Personal Profile',
        },
    },
    {
        apiKey: 'lifetime.impression_source_sound',
        column: {
            id: 'lifetime_impression_source_sound',
            dataType: 'int',
            alias: 'Impression Source Sound',
        },
    },
    {
        apiKey: 'lifetime.impression_source_unspecified',
        column: {
            id: 'lifetime_impression_source_unspecified',
            dataType: 'int',
            alias: 'Impression Source Unspecified',
        },
    },
    {
        apiKey: 'lifetime.impressions',
        column: {
            id: 'lifetime_impressions',
            dataType: 'int',
            alias: 'Impressions',
        },
    },
    {
        apiKey: 'lifetime.impressions_follower',
        column: {
            id: 'lifetime_impressions_follower',
            dataType: 'int',
            alias: 'Fan Impressions',
        },
    },
    {
        apiKey: 'lifetime.impressions_follower_unique',
        column: {
            id: 'lifetime_impressions_follower_unique',
            dataType: 'int',
            alias: 'Fan Reach',
        },
    },
    {
        apiKey: 'lifetime.impressions_nonfollower',
        column: {
            id: 'lifetime_impressions_nonfollower',
            dataType: 'int',
            alias: 'Non-fan Impressions',
        },
    },
    {
        apiKey: 'lifetime.impressions_nonviral',
        column: {
            id: 'lifetime_impressions_nonviral',
            dataType: 'int',
            alias: 'Non-viral Impressions',
        },
    },
    {
        apiKey: 'lifetime.impressions_organic',
        column: {
            id: 'lifetime_impressions_organic',
            dataType: 'int',
            alias: 'Organic Impressions',
        },
    },
    {
        apiKey: 'lifetime.impressions_paid',
        column: {
            id: 'lifetime_impressions_paid',
            dataType: 'int',
            alias: 'Paid Impressions',
        },
    },
    {
        apiKey: 'lifetime.impressions_unique',
        column: {
            id: 'lifetime_impressions_unique',
            dataType: 'int',
            alias: 'Reach',
        },
    },
    {
        apiKey: 'lifetime.impressions_viral',
        column: {
            id: 'lifetime_impressions_viral',
            dataType: 'int',
            alias: 'Viral Impressions',
        },
    },
    {
        apiKey: 'lifetime.likes',
        column: {
            id: 'lifetime_likes',
            dataType: 'int',
            alias: 'Likes',
        },
    },
    {
        apiKey: 'lifetime.post_app_installs',
        column: {
            id: 'lifetime_post_app_installs',
            dataType: 'int',
            alias: 'App Install Attempts',
        },
    },
    {
        apiKey: 'lifetime.post_app_opens',
        column: {
            id: 'lifetime_post_app_opens',
            dataType: 'int',
            alias: 'App Opens',
        },
    },
    {
        apiKey: 'lifetime.link_in_bio_clicks',
        column: {
            id: 'lifetime_link_in_bio_clicks',
            dataType: 'int',
            alias: 'SproutLink Clicks',
        },
    },
    {
        apiKey: 'lifetime.sentiment_comments_positive_count',
        column: {
            id: 'lifetime_sentiment_comments_positive_count',
            dataType: 'int',
            alias: 'Positive Comments',
        },
    },
    {
        apiKey: 'lifetime.sentiment_comments_negative_count',
        column: {
            id: 'lifetime_sentiment_comments_negative_count',
            dataType: 'int',
            alias: 'Negative Comments',
        },
    },
    {
        apiKey: 'lifetime.sentiment_comments_neutral_count',
        column: {
            id: 'lifetime_sentiment_comments_neutral_count',
            dataType: 'int',
            alias: 'Neutral Comments',
        },
    },
    {
        apiKey: 'lifetime.sentiment_comments_unclassified_count',
        column: {
            id: 'lifetime_sentiment_comments_unclassified_count',
            dataType: 'int',
            alias: 'Unclassified Comments',
        },
    },
    {
        apiKey: 'lifetime.post_content_clicks',
        column: {
            id: 'lifetime_post_content_clicks',
            dataType: 'int',
            alias: 'Post Clicks (All)',
        },
    },
    {
        apiKey: 'lifetime.post_content_clicks_other',
        column: {
            id: 'lifetime_post_content_clicks_other',
            dataType: 'int',
            alias: 'Other Post Clicks',
        },
    },
    {
        apiKey: 'lifetime.post_detail_expand_clicks',
        column: {
            id: 'lifetime_post_detail_expand_clicks',
            dataType: 'int',
            alias: 'Post Detail Expand Clicks',
        },
    },
    {
        apiKey: 'lifetime.post_followers_gained',
        column: {
            id: 'lifetime_post_followers_gained',
            dataType: 'int',
            alias: 'Follows from Posts',
        },
    },
    {
        apiKey: 'lifetime.post_followers_lost',
        column: {
            id: 'lifetime_post_followers_lost',
            dataType: 'int',
            alias: 'Unfollows from Posts',
        },
    },
    {
        apiKey: 'lifetime.post_hashtag_clicks',
        column: {
            id: 'lifetime_post_hashtag_clicks',
            dataType: 'int',
            alias: 'Post Hashtag Clicks',
        },
    },
    {
        apiKey: 'lifetime.post_link_clicks',
        column: {
            id: 'lifetime_post_link_clicks',
            dataType: 'int',
            alias: 'Post Link Clicks',
        },
    },
    {
        apiKey: 'lifetime.post_media_clicks',
        column: {
            id: 'lifetime_post_media_clicks',
            dataType: 'int',
            alias: 'Post Media Clicks',
        },
    },
    {
        apiKey: 'lifetime.post_media_views',
        column: {
            id: 'lifetime_post_media_views',
            dataType: 'int',
            alias: 'Media Views',
        },
    },
    {
        apiKey: 'lifetime.post_other_clicks_unique',
        column: {
            id: 'lifetime_post_other_clicks_unique',
            dataType: 'int',
            alias: 'Unique Other Post Clicks',
        },
    },
    {
        apiKey: 'lifetime.post_photo_view_clicks',
        column: {
            id: 'lifetime_post_photo_view_clicks',
            dataType: 'int',
            alias: 'Post Photo View Clicks',
        },
    },
    {
        apiKey: 'lifetime.post_profile_clicks',
        column: {
            id: 'lifetime_post_profile_clicks',
            dataType: 'int',
            alias: 'Profile Clicks',
        },
    },
    {
        apiKey: 'lifetime.post_shares_count',
        column: {
            id: 'lifetime_post_shares_count',
            dataType: 'int',
            alias: 'Post Shares',
        },
    },
    {
        apiKey: 'lifetime.post_video_play_clicks',
        column: {
            id: 'lifetime_post_video_play_clicks',
            dataType: 'int',
            alias: 'Post Video Play Clicks',
        },
    },
    {
        apiKey: 'lifetime.question_answers',
        column: {
            id: 'lifetime_question_answers',
            dataType: 'int',
            alias: 'Answers',
        },
    },
    {
        apiKey: 'lifetime.quotes_count',
        column: {
            id: 'lifetime_quotes_count',
            dataType: 'int',
            alias: 'Quotes',
        },
    },
    {
        apiKey: 'lifetime.reactions',
        column: {
            id: 'lifetime_reactions',
            dataType: 'int',
            alias: 'Reactions',
        },
    },
    {
        apiKey: 'lifetime.reactions_angry',
        column: {
            id: 'lifetime_reactions_angry',
            dataType: 'int',
            alias: 'Angry Reactions',
        },
    },
    {
        apiKey: 'lifetime.reactions_haha',
        column: {
            id: 'lifetime_reactions_haha',
            dataType: 'int',
            alias: 'Haha Reactions',
        },
    },
    {
        apiKey: 'lifetime.reactions_love',
        column: {
            id: 'lifetime_reactions_love',
            dataType: 'int',
            alias: 'Love Reactions',
        },
    },
    {
        apiKey: 'lifetime.reactions_sad',
        column: {
            id: 'lifetime_reactions_sad',
            dataType: 'int',
            alias: 'Sad Reactions',
        },
    },
    {
        apiKey: 'lifetime.reactions_wow',
        column: {
            id: 'lifetime_reactions_wow',
            dataType: 'int',
            alias: 'Wow Reactions',
        },
    },
    {
        apiKey: 'lifetime.red_video_views',
        column: {
            id: 'lifetime_red_video_views',
            dataType: 'int',
            alias: 'YT Red Video Views',
        },
    },
    {
        apiKey: 'lifetime.reels_unique_session_plays',
        column: {
            id: 'lifetime_reels_unique_session_plays',
            dataType: 'int',
            alias: 'FB and IG Reels Unique Session Plays',
        },
    },
    {
        apiKey: 'lifetime.reposts_count',
        column: {
            id: 'lifetime_reposts_count',
            dataType: 'int',
            alias: 'Reposts',
        },
    },
    {
        apiKey: 'lifetime.saves',
        column: {
            id: 'lifetime_saves',
            dataType: 'int',
            alias: 'Saves',
        },
    },
    {
        apiKey: 'lifetime.shares_count',
        column: {
            id: 'lifetime_shares_count',
            dataType: 'int',
            alias: 'Shares',
        },
    },
    {
        apiKey: 'lifetime.story_exits',
        column: {
            id: 'lifetime_story_exits',
            dataType: 'int',
            alias: 'Story Exits',
        },
    },
    {
        apiKey: 'lifetime.story_taps_back',
        column: {
            id: 'lifetime_story_taps_back',
            dataType: 'int',
            alias: 'Story Taps Back',
        },
    },
    {
        apiKey: 'lifetime.story_taps_forward',
        column: {
            id: 'lifetime_story_taps_forward',
            dataType: 'int',
            alias: 'Story Taps Forward',
        },
    },
    {
        apiKey: 'lifetime.vote_count',
        column: {
            id: 'lifetime_vote_count',
            dataType: 'int',
            alias: 'Poll Votes',
        },
    },
    {
        apiKey: 'lifetime.subscribers_gained',
        column: {
            id: 'lifetime_subscribers_gained',
            dataType: 'int',
            alias: 'Subscribers Gained',
        },
    },
    {
        apiKey: 'lifetime.subscribers_lost',
        column: {
            id: 'lifetime_subscribers_lost',
            dataType: 'int',
            alias: 'Subscribers Lost',
        },
    },
    {
        apiKey: 'lifetime.video_ad_break_cost_per_impression',
        column: {
            id: 'lifetime_video_ad_break_cost_per_impression',
            dataType: 'float',
            alias: 'Video Ad Break Ad Cost per Impression (CPM)',
        },
    },
    {
        apiKey: 'lifetime.video_ad_break_earnings',
        column: {
            id: 'lifetime_video_ad_break_earnings',
            dataType: 'int',
            alias: 'Video Ad Break Ad Earnings',
        },
    },
    {
        apiKey: 'lifetime.video_ad_break_impressions',
        column: {
            id: 'lifetime_video_ad_break_impressions',
            dataType: 'int',
            alias: 'Video Ad Break Ad Impressions',
        },
    },
    {
        apiKey: 'lifetime.video_view_percentage',
        column: {
            id: 'lifetime_video_view_percentage',
            dataType: 'int',
            alias: 'Video View Percentage',
        },
    },
    {
        apiKey: 'lifetime.video_view_time',
        column: {
            id: 'lifetime_video_view_time',
            dataType: 'int',
            alias: 'Video View Time',
        },
    },
    {
        apiKey: 'lifetime.video_view_time_organic',
        column: {
            id: 'lifetime_video_view_time_organic',
            dataType: 'int',
            alias: 'Organic Video View Time',
        },
    },
    {
        apiKey: 'lifetime.video_view_time_paid',
        column: {
            id: 'lifetime_video_view_time_paid',
            dataType: 'int',
            alias: 'Paid Video View Time',
        },
    },
    {
        apiKey: 'lifetime.video_view_time_per_view',
        column: {
            id: 'lifetime_video_view_time_per_view',
            dataType: 'float',
            alias: 'Average Video Time Watched',
        },
    },
    {
        apiKey: 'lifetime.video_views',
        column: {
            id: 'lifetime_video_views',
            dataType: 'int',
            alias: 'Video Views',
        },
    },
    {
        apiKey: 'lifetime.video_views_30s_complete',
        column: {
            id: 'lifetime_video_views_30s_complete',
            dataType: 'int',
            alias: 'Full Video Views',
        },
    },
    {
        apiKey: 'lifetime.video_views_30s_complete_autoplay',
        column: {
            id: 'lifetime_video_views_30s_complete_autoplay',
            dataType: 'int',
            alias: 'Autoplay Full Video Views',
        },
    },
    {
        apiKey: 'lifetime.video_views_30s_complete_click_to_play',
        column: {
            id: 'lifetime_video_views_30s_complete_click_to_play',
            dataType: 'int',
            alias: 'Click to Play Full Video Views',
        },
    },
    {
        apiKey: 'lifetime.video_views_30s_complete_organic',
        column: {
            id: 'lifetime_video_views_30s_complete_organic',
            dataType: 'int',
            alias: 'Organic Full Video Views',
        },
    },
    {
        apiKey: 'lifetime.video_views_30s_complete_paid',
        column: {
            id: 'lifetime_video_views_30s_complete_paid',
            dataType: 'int',
            alias: 'Paid Full Video Views',
        },
    },
    {
        apiKey: 'lifetime.video_views_30s_complete_unique',
        column: {
            id: 'lifetime_video_views_30s_complete_unique',
            dataType: 'int',
            alias: 'Unique Full Video Views',
        },
    },
    {
        apiKey: 'lifetime.video_views_autoplay',
        column: {
            id: 'lifetime_video_views_autoplay',
            dataType: 'int',
            alias: 'Autoplay Video Views',
        },
    },
    {
        apiKey: 'lifetime.video_views_click_to_play',
        column: {
            id: 'lifetime_video_views_click_to_play',
            dataType: 'int',
            alias: 'Click to Play Video Views',
        },
    },
    {
        apiKey: 'lifetime.video_views_organic',
        column: {
            id: 'lifetime_video_views_organic',
            dataType: 'int',
            alias: 'Organic Video Views',
        },
    },
    {
        apiKey: 'lifetime.video_views_p100_per_view',
        column: {
            id: 'lifetime_video_views_p100_per_view',
            dataType: 'float',
            alias: 'Full Video Watch Rate',
        },
    },
    {
        apiKey: 'lifetime.video_views_p95',
        column: {
            id: 'lifetime_video_views_p95',
            dataType: 'int',
            alias: '95% Video Views',
        },
    },
    {
        apiKey: 'lifetime.video_views_p95_organic',
        column: {
            id: 'lifetime_video_views_p95_organic',
            dataType: 'int',
            alias: 'Organic 95% Video Views',
        },
    },
    {
        apiKey: 'lifetime.video_views_p95_organic_unique',
        column: {
            id: 'lifetime_video_views_p95_organic_unique',
            dataType: 'int',
            alias: 'Unique Organic 95% Video Views',
        },
    },
    {
        apiKey: 'lifetime.video_views_p95_paid',
        column: {
            id: 'lifetime_video_views_p95_paid',
            dataType: 'int',
            alias: 'Paid 95% Video Views',
        },
    },
    {
        apiKey: 'lifetime.video_views_p95_paid_unique',
        column: {
            id: 'lifetime_video_views_p95_paid_unique',
            dataType: 'int',
            alias: 'Unique Paid 95% Video Views',
        },
    },
    {
        apiKey: 'lifetime.video_views_paid',
        column: {
            id: 'lifetime_video_views_paid',
            dataType: 'int',
            alias: 'Paid Video Views',
        },
    },
    {
        apiKey: 'lifetime.video_views_partial',
        column: {
            id: 'lifetime_video_views_partial',
            dataType: 'int',
            alias: 'Partial Video Views',
        },
    },
    {
        apiKey: 'lifetime.video_views_partial_autoplay',
        column: {
            id: 'lifetime_video_views_partial_autoplay',
            dataType: 'int',
            alias: 'Autoplay Partial Video Views',
        },
    },
    {
        apiKey: 'lifetime.video_views_partial_click_to_play',
        column: {
            id: 'lifetime_video_views_partial_click_to_play',
            dataType: 'int',
            alias: 'Click to Play Partial Video Views',
        },
    },
    {
        apiKey: 'lifetime.video_views_partial_organic',
        column: {
            id: 'lifetime_video_views_partial_organic',
            dataType: 'int',
            alias: 'Organic Partial Video Views',
        },
    },
    {
        apiKey: 'lifetime.video_views_partial_paid',
        column: {
            id: 'lifetime_video_views_partial_paid',
            dataType: 'int',
            alias: 'Paid Partial Video Views',
        },
    },
    {
        apiKey: 'lifetime.video_views_sound_off',
        column: {
            id: 'lifetime_video_views_sound_off',
            dataType: 'int',
            alias: 'Sound off Video Views',
        },
    },
    {
        apiKey: 'lifetime.video_views_sound_on',
        column: {
            id: 'lifetime_video_views_sound_on',
            dataType: 'int',
            alias: 'Sound on Video Views',
        },
    },
    {
        apiKey: 'lifetime.videos_added_to_playlist',
        column: {
            id: 'lifetime_videos_added_to_playlist',
            dataType: 'int',
            alias: 'Video Added to Playlist',
        },
    },
    {
        apiKey: 'lifetime.videos_removed_from_playlist',
        column: {
            id: 'lifetime_videos_removed_from_playlist',
            dataType: 'int',
            alias: 'Video From to Playlist',
        },
    },
    {
        apiKey: 'lifetime.views',
        column: {
            id: 'lifetime_views',
            dataType: 'int',
            alias: 'Views'
        },
    },
    {
        apiKey: 'video_length',
        column: {
            id: 'video_length',
            dataType: 'int',
            alias: 'Video Length',
        },
    },
];
export { POST_FIELDS, POST_METRICS, };
